import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import BlogHero from './components/BlogHero';
import BlogList from './components/BlogList';

const BlogPage = () => {
  useEffect(() => {
    document.title = 'ブログ・新着情報 - 岡山市北区の訪問介護サービス｜ヘルパーステーションおかやま';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'ヘルパーステーションおかやまのブログ・新着情報。岡山市北区の介護に関するお役立ち情報、当社の最新ニュース、イベント情報などを発信しています。');
    }

    // Add Blog Schema
    const blogSchema = document.createElement('script');
    blogSchema.type = 'application/ld+json';
    blogSchema.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "ヘルパーステーションおかやま ブログ・新着情報",
      "description": "岡山市北区の訪問介護に関するお役立ち情報、最新ニュース、イベント情報を発信",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://helper-station-okayama.example.com'}/blog`,
      "publisher": {
        "@type": "Organization",
        "name": "おかやま訪問介護株式会社",
        "logo": {
          "@type": "ImageObject",
          "url": `${import.meta.env.VITE_SITE_URL || 'https://helper-station-okayama.example.com'}/vite.svg`
        }
      }
    });
    document.head.appendChild(blogSchema);

    return () => {
      if (blogSchema.parentNode) {
        blogSchema.parentNode.removeChild(blogSchema);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <BlogHero />
        <BlogList />
      </main>
      <Footer />
    </div>
  );
};

export default BlogPage;